import { useMutation, useQuery } from '@tanstack/react-query';
import type { PlaceAutocompleteSuggestion, ProspectResult, ProspectSearchQuery } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

export function useProspectSearchQuery(query: ProspectSearchQuery | null) {
  return useQuery({
    queryKey: ['prospecting-search', query],
    queryFn: () => {
      const params = new URLSearchParams({
        keyword: query!.keyword,
        location: query!.location,
        radiusKm: String(query!.radiusKm),
      });
      return api.get<ProspectResult[]>(`/prospecting/search?${params.toString()}`);
    },
    enabled: query !== null,
    retry: false,
  });
}

export function useResolveGoogleMapsUrl() {
  return useMutation({
    mutationFn: (googleMapsUrl: string) => api.post<ProspectResult | null>('/prospecting/resolve-url', { googleMapsUrl }),
  });
}

/** Debounced by the caller (`LocationAutocomplete`), not here — this hook
 * just fetches for whatever `input` it's given. */
export function useLocationAutocompleteQuery(input: string) {
  return useQuery({
    queryKey: ['prospecting-autocomplete', input],
    queryFn: () => api.get<PlaceAutocompleteSuggestion[]>(`/prospecting/autocomplete?input=${encodeURIComponent(input)}`),
    enabled: input.trim().length >= 3,
    staleTime: 60_000,
  });
}
